import { createApp } from "vue";
import { createHead } from '@vueuse/head'
import VueEasyLightbox from "vue-easy-lightbox";
import router from "./routes";
import "bootstrap";
import "./index.css";
import App from "./App.vue";

let app = createApp(App);
const head = createHead();
app.use(router);
app.use(VueEasyLightbox);
app.use(head);
app.mount("#app");
